import React from 'react';
import { Dialog, DialogContent, DialogContentText } from '@mui/material';
import { url_payment_api, url_backend, url_front, prefix_tittle} from '../../../config/paymentConfig';
import { getMediosDePagosActivosPayment, obtenerMontoTotalACobrar } from '../../../sagas/PedidoSaga/calls';
import PaymentGatewayRenderer from './PaymentGatewayRenderer';
import { getGenerateSignature } from '../../../sagas/PedidoSaga/calls';
class CustomPaymentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      listaMediosPagoPayment: null,
      montoTotalCalculado: null,
    };
  }

  // componentDidMount = async () => {
  //   try {
  //     const listaMediosPagoPayment = await getMediosDePagosActivosPayment();
      
  //     // Generar solo el nombre del medio y su signature
  //     console.log("pedido id signature",this.props.pedidoId,);
  //     console.log("pedidoPrecioFinal signature",this.props.pedidoPrecioFinal);
  //     console.log("pedido data componente",this.props.pedidoData)
  //     const mediosPagoSimplificados = await Promise.all(
  //       listaMediosPagoPayment.map(async (medio) => {
  //         const signature = await getGenerateSignature(
  //           this.props.pedidoId,
  //           this.props.pedidoPrecioFinal,
  //           "biller1",
  //           medio.nombre.toLowerCase(),
  //           ""
  //         );
  //         return {
  //           nombre: medio.nombre.toLowerCase(),
  //           signature
  //         };
  //       })
  //     );
      
  //     this.setState({ listaMediosPagoPayment: mediosPagoSimplificados });
  //   } catch (error) {
  //     console.error("Error cargando medios de pago:", error);
  //   }
  // };


    // Función reutilizable para generar los medios de pago
    generarMediosDePago = async () => {
      // Validamos que tengamos los datos necesarios
      if (!this.props.pedidoId) {
        console.warn('Faltan datos para generar firmas (pedidoId)');
        return;
      }
      try {
          const responseCalculoMontoTotal = await obtenerMontoTotalACobrar({
            IdPedido: this.props.pedidoId,
            IdInstalacion: 3,
            IdFormaEntrega: this.props.idFormaEntrega,
          });
          const montoTotalACobrar = responseCalculoMontoTotal.montoTotal;
          console.log("Generando firmas con:", {
            pedidoId: this.props.pedidoId,
            precioFinal: montoTotalACobrar
          });

        const listaMediosPagoPayment = await getMediosDePagosActivosPayment();
        
        const mediosPagoSimplificados = await Promise.all(
          listaMediosPagoPayment.map(async (medio) => {
            const signature = await getGenerateSignature(
              this.props.pedidoId,
              montoTotalACobrar,
              "biller1",
              medio.nombre.toLowerCase(),
              ""
            );
            return {
              nombre: medio.nombre.toLowerCase(),
              signature
            };
          })
        );
        
        this.setState({ 
          listaMediosPagoPayment: mediosPagoSimplificados,
          montoTotalCalculado: montoTotalACobrar,
          loading: false
        });
      } catch (error) {
        console.error("Error cargando medios de pago:", error);
        this.setState({ 
          error: "Error al cargar medios de pago",
          loading: false
        });
      }
    };

      // Se ejecuta al montar el componente
  componentDidMount = async () => {
    await this.generarMediosDePago();
  };

  // Se ejecuta cuando cambian las props
  componentDidUpdate = async (prevProps) => {
    // Solo regeneramos si cambian estos valores críticos
    if (
      this.props.pedidoId !== prevProps.pedidoId ||
      this.props.pedidoPrecioFinal !== prevProps.pedidoPrecioFinal ||
      this.props.open !== prevProps.open
    ) {
      // Solo regenerar si el diálogo está abierto
      if (this.props.open) {
        this.setState({ loading: true });
        await this.generarMediosDePago();
      }
    }
  };
  buildCommonProps = (signature) => {
    const { pedidoId, pedidoPrecioFinal, dataUser = {} } = this.props;
    const { montoTotalCalculado } = this.state;
    console.log("buildCommonProps in MODAL PAGOS", this.props);
    var payerFullName = (dataUser && dataUser.nombre && dataUser.apellido)
    
    return {
      biller: "biller1",
      "server-url": url_payment_api,
      "webhook-url": `${url_backend}/api/Pedido/WebHookCheckout`,
      "url-success": `${url_front}/#/FinalizarCompra?result=success`,
      "url-fail": `${url_front}/#/FinalizarCompra?result=fail`,
      "url-pending": `${url_front}/#/FinalizarCompra?result=pending`,
      "product-title": `${prefix_tittle}Pago pedido #${pedidoId}`,
      amount: montoTotalCalculado,
      "external-id": pedidoId,
      "payer-full-name": payerFullName,
      "payer-email": (dataUser && dataUser.nombreUsuario) || "email@ejemplo.com",
      "payer-document-type": "DNI",
      "payer-document": (dataUser && dataUser.dni) || "00000000",
      country: "AR",
      "enable-btn": "true",
      signature: signature
    };
  };
  
  render() {
    return (
      <Dialog open={this.props.open} onClose={this.props.onClose}>
        <DialogContent>
          <DialogContentText style={{marginBottom:"0px"}}>
            Elija una de las siguientes opciones de pago.
          </DialogContentText>
          
          <PaymentGatewayRenderer 
            mediosPago={this.state.listaMediosPagoPayment}
            buildCommonProps={(signature) => this.buildCommonProps(signature)}
          />
        </DialogContent>
      </Dialog>
    );
  }
}

export default CustomPaymentDialog;